import { Box, IconButton, styled } from "@mui/material";
import { FC, useCallback, useEffect, useState } from "react";
import { IconNorth } from "@/assets/icons";
import { background, border, icon } from "@/theme/colors";
import { rounded, spacing } from "@/theme/variables";

const SCROLL_THRESHOLD = 300;

type TScrollToTopButtonProps = {
  scrollParent: HTMLElement | null;
};

export const ScrollToTopButton: FC<TScrollToTopButtonProps> = ({ scrollParent }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!scrollParent) return;

    const handleScroll = () => {
      setVisible(scrollParent.scrollTop > SCROLL_THRESHOLD);
    };

    scrollParent.addEventListener("scroll", handleScroll, { passive: true });
    return () => scrollParent.removeEventListener("scroll", handleScroll);
  }, [scrollParent]);

  const scrollToTop = useCallback(() => {
    scrollParent?.scrollTo({ top: 0, behavior: "smooth" });
  }, [scrollParent]);

  return (
    <ScrollToTopAnchor visibility={visible ? "visible" : "hidden"}>
      <ScrollToTopIconButton onClick={scrollToTop}>
        <IconNorth fontSize="24px" color={icon.default} />
      </ScrollToTopIconButton>
    </ScrollToTopAnchor>
  );
};

const ScrollToTopAnchor = styled(Box)({
  position: "sticky",
  bottom: 0,
  alignSelf: "flex-end",
  marginRight: spacing.xs,
  zIndex: 1,
});

const ScrollToTopIconButton = styled(IconButton)({
  width: 44,
  height: 44,
  backgroundColor: background.white,
  border: `1px solid ${border.higher}`,
  borderRadius: rounded.full,
  "&:hover": { backgroundColor: background.primary },
});
